import { c as _c } from "react/compiler-runtime";
import { getSortedRows } from 'src/features/summary-table/utils';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../Context';
import type { OffersFilterStoreState } from '../../types';
import { getFilteredOffers, getSortedOffers } from './utils';
export function useFilteredAndSortedOffers(t0) {
  const $ = _c(17);
  const {
    allOffers,
    featuredSequence
  } = t0;
  const {
    areFiltersEnabled,
    preComputedFilterOfferIds,
    appliedFilters: t1,
    isLoading
  } = useOffersFilterStore(useShallow(_temp));
  const {
    creditRangeFilter,
    issuerFilter,
    cardFeatureFilter,
    sortBy
  } = t1;
  if (!areFiltersEnabled) {
    let t2;
    if ($[0] !== allOffers || $[1] !== featuredSequence) {
      t2 = getSortedRows(allOffers, featuredSequence);
      $[0] = allOffers;
      $[1] = featuredSequence;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== isLoading || $[4] !== t2) {
      t3 = {
        isLoading,
        offers: t2
      };
      $[3] = isLoading;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== allOffers || $[7] !== cardFeatureFilter || $[8] !== creditRangeFilter || $[9] !== featuredSequence || $[10] !== issuerFilter || $[11] !== preComputedFilterOfferIds || $[12] !== sortBy) {
    const filteredOffers = getFilteredOffers({
      allOffers,
      creditRangeFilter,
      issuerFilter,
      preComputedFilterOfferIds,
      cardFeatureFilter
    });
    t2 = getSortedOffers({
      featuredSequence,
      filteredOffers,
      preComputedFilterOfferIds,
      sortBy
    });
    $[6] = allOffers;
    $[7] = cardFeatureFilter;
    $[8] = creditRangeFilter;
    $[9] = featuredSequence;
    $[10] = issuerFilter;
    $[11] = preComputedFilterOfferIds;
    $[12] = sortBy;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const sequencedOffers = t2;
  let t3;
  if ($[14] !== isLoading || $[15] !== sequencedOffers) {
    t3 = {
      isLoading,
      offers: sequencedOffers
    };
    $[14] = isLoading;
    $[15] = sequencedOffers;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}
function _temp(state) {
  return {
    areFiltersEnabled: state.areFiltersEnabled,
    preComputedFilterOfferIds: state.preComputedFilterOfferIds,
    appliedFilters: state.appliedFilters,
    isLoading: state.isLoading
  };
}